'use client';

import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Checkbox,
  HStack,
  Button,
  Text,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import ActiveSwitch from '../../components/ActiveSwitch';

interface TableProps {
  headers: any;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaPermissoes({ headers, dados, valoPesquisa }: TableProps) {
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [tableData, setTableData] = useState(dados);



  const [fieltedData, setFilteredData] = useState(dados);
  useEffect(() => {
    setTableData(dados);
    setFilteredData(dados);
  }, [dados]);

  useEffect(() => {
    if (valoPesquisa.trim() === '') {
      setFilteredData(tableData);
    } else {
      const filtered = tableData.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(valoPesquisa.toLowerCase())
        )
      );
      setFilteredData(filtered);
    }
  }, [valoPesquisa, tableData]);


  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedRows(new Set(tableData.map((item) => item.id)));
    } else {
      setSelectedRows(new Set());
    }
  };

  const handleSelectRow = (id: number, checked: boolean) => {
    const newSelected = new Set(selectedRows);
    if (checked) {
      newSelected.add(id);
    } else {
      newSelected.delete(id);
    }
    setSelectedRows(newSelected);
  };

  const handleSwitchChange = (id: number) => {
    setTableData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, ativo: !item.ativo } : item
      )
    );
  };

  const handleConfirmClick = () => {
    const selectedObjects = tableData.filter((row) => selectedRows.has(row.id));
  };


  return (
    <Box overflowX="auto">
      <Table variant="striped" size="sm">
        <Thead>
          <Tr>
            {headers
              .filter((header: any) => header.isVisible)
              .map((header: any, index: any) => (
                <Th
                  key={index}
                  color="white"
                  bg="#0f4f6d"
                  textAlign="center"
                  width={header.width}
                  borderTopLeftRadius={index === 0 ? 'lg' : '0'}
                  borderTopRightRadius={index === headers.length - 1 ? 'lg' : '0'}
                  p={2}
                >
                  {header.key === 'checkbox' ? (
                    <Checkbox
                      size="sm"
                      isChecked={selectedRows.size === tableData.length}
                      isIndeterminate={selectedRows.size > 0 && selectedRows.size < tableData.length}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                  ) : (
                    <Text>{header.label}</Text>
                  )}
                </Th>
              ))}
          </Tr>
        </Thead>
        <Tbody>
          {fieltedData.map((item) => (
            <Tr key={item.id} bg={selectedRows.has(item.id) ? 'gray.100' : 'white'}>
              {headers
                .filter((header: any) => header.isVisible)
                .map((header: any) => (
                  <Td key={header.key} textAlign="center">
                    {header.key === 'checkbox' ? (
                      <Checkbox
                        size="sm"
                        isChecked={selectedRows.has(item.id)}
                        onChange={(e) => handleSelectRow(item.id, e.target.checked)}
                      />
                    ) : header.key === 'ativo' ? (
                      <Box display="flex" justifyContent="center" alignItems="center" p={0}>
                        <ActiveSwitch
                          size="sm"
                          isChecked={item.ativo}
                          onChange={() => handleSwitchChange(item.id)}
                        />
                      </Box>
                    ) : (
                      //@ts-ignore
                      item[header.key]
                    )}
                  </Td>
                ))}
            </Tr>
          ))}
        </Tbody>
      </Table>

      <HStack pt={4} justify="flex-end">
        <Button size="md" type="submit" colorScheme="blue" onClick={handleConfirmClick}>
          Confirmar
        </Button>
      </HStack>
    </Box>
  );
}
